// @flow

import type {StatelessFunctionalComponent} from 'react';

import {themeTokens} from '@travel-frontend/themes';
import SyncLoader from 'react-spinners/SyncLoader';

import {Container} from 'components/PageLoading/components/Icon/components/Container';

const {colors} = themeTokens['aidu-de'];

export const Icon: StatelessFunctionalComponent<> = () => (
  <Container>
    <SyncLoader size={18} color={colors.interactionPrimary} />
  </Container>
);
